import { createGlobalStyle, css } from 'styled-components';

function columnGenerator(suffix) {
	let style = '';

	for (let i = 1; i <= 12; i++) {
		style += suffix ? `.col-${suffix}-${i}` : `.col-${i}`;
		style += `{ width: ${(100 / 12) * i}% }`;
	}

	return style;
}

const HelperClass = createGlobalStyle`${css`
	/* //! Fonts */
	.montserrat-300 {
		font-family: var(--montserrat_arm);
		font-weight: 300 !important;
	}

	.montserrat-400 {
		font-family: var(--montserrat_arm);
		font-weight: 400 !important;
	}

	.montserrat-500 {
		font-family: var(--montserrat_arm);
		font-weight: 500 !important;
	}

	.montserrat-550 {
		font-family: var(--montserrat_arm);
		font-weight: 550 !important;
	}

	.montserrat-600 {
		font-family: var(--montserrat_arm);
		font-weight: 600 !important;
	}

	/* //! Colors */
	.red-1100 {
		color: var(--red1100);
	}

	.red-1000 {
		color: var(--red1000);
	}

	.white-1000 {
		color: var(--white1000);
	}

	.black-1000 {
		color: var(--black1000);
	}

	.black-900 {
		color: var(--black900);
	}

	.black-850 {
		color: var(--black850);
	}

	.black-800 {
		color: var(--black800);
	}

	.black-500 {
		color: var(--black500);
	}

	.tiffany-blue {
		color: var(--tiffanyBlue);
	}

	.green-1100 {
		color: var(--green1100);
	}

	.white-06 {
		color: var(--white06);
	}

	/* //! External */
	.line-clamp {
		&-1 {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			-webkit-line-clamp: 1;
		}

		&-2 {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			-webkit-line-clamp: 2;
		}

		&-3 {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			-webkit-line-clamp: 3;
		}
	}

	/* //! Global Animations */
	.wrapper-button {
		display: flex;
		width: fit-content;
		height: fit-content;
		scale: 0;

		&.active-button {
			scale: 1 !important;
			transition: calc(var(--trTime) * 2) ease-out;
		}
	}

	/* //! Grid */
	.row {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(var(--colPadding) * -1);

		> * {
			width: 100%;
			padding: 0 var(--colPadding);
		}

		/* //! 2560 */
		${columnGenerator()};

		/* //! 1920 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeXLMin}) {
			${columnGenerator('dxl')}
		}

		/* //! 1536 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeLMin}) {
			${columnGenerator('dl')}
		}

		/* //! 1366 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeMMin}) {
			${columnGenerator('dm')}
		}

		/* //! 1280 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeSMin}) {
			${columnGenerator('ds')}
		}

		/* //! 1024 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeMin}) {
			${columnGenerator('t')}
		}

		/* //! 768 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeXMin}) {
			${columnGenerator('dx')}
		}

		/* //! Mobile */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeSMin}) {
			${columnGenerator('m')}
		}
	}
`}`;

export default HelperClass;
